import { react2angular } from 'react2angular';

import app from '../../../../browser/addform/scripts/app';

import { CoworkingPlacementApplication } from './CoworkingPlacementApplication';

app.component('coworkingPlacementApplication', react2angular(CoworkingPlacementApplication, [], ['httpApi', 'logger']));
